import { lazy, Suspense } from "react";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "./Components/StyledComponent/Toast";
import ToastProvider from "./Context/ToastProvider/ToastProvider";
import { renderLoader } from "./Constant/Loader";
import { AutherRoutes } from "./Routes/AutherRoutes";

const Main = lazy(() => import("./Pages/Main"));
const LoginPage = lazy(() => import("./Pages/Onboarding/LoginPage/LoginPage"));
const CompleteAuth = lazy( () => import("./Pages/CompleteAuth") );

function App() {
  return (
    <>
      <Suspense fallback={renderLoader()}>
        <ToastProvider>
          <ToastContainer />
          <BrowserRouter>
            <Routes>
                <Route path="complete-auth" element={<CompleteAuth />} />
                <Route element={<AutherRoutes />}>
                  <Route path="login" element={<LoginPage />} />
                  <Route path="/*" element={<Main />} />
                </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </Suspense>
    </>
  );
}

export default App;
